import EmployeeCardActivator from '@/api/employee-card-activator'
import Employee from '@/api/employee'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  status_id: 1,
  employees: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EMPLOYEES(state, data) {
    state.employees = data
  },
  SET_STATUS_ID(state, value) {
    state.status_id = value
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        filter: {
          status_id: context.state.status_id
        }
      },
      attributes
    )

    return EmployeeCardActivator.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return EmployeeCardActivator.store(data)
  },

  update(context, { id, ...data }) {
    return EmployeeCardActivator.update(id, data)
  },

  async checkCurrentEmployeeCardStatus(context, data) {
    return await EmployeeCardActivator.checkCurrentEmployeeCardStatus(data)
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        setup_staff_information: 'staff_id,name_en,name_kh'
      },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('SET_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  }
}
